import styled, { css } from 'styled-components';
import {
  DIVIDER_ORIENTATION_VERTICAL,
  type DividerOrientation,
} from './Divider.constants';

interface RootProps {
  $orientation: DividerOrientation;
  $thickness: number;
  $length?: number | string;
  $inset: number | string;
}

const lengthValue = (l?: number | string): string => {
  if (l === undefined) return '100%';
  return typeof l === 'number' ? `${l}px` : l;
};

const insetValue = (i: number | string): string =>
  typeof i === 'number' ? `${i}px` : i;

/**
 * Faint hairline. Reads `outlineVariant` from the theme but falls back to a
 * 10%-mixed `onSurface` (matching the prototype's
 * `color-mix(in oklch, on-surface 10%, transparent)`) when the consumer's
 * theme doesn't expose tokens, so the atom stays theme-agnostic.
 */
export const Root = styled.span<RootProps>`
  display: block;
  flex: 0 0 auto;
  border: 0;
  background: ${({ theme: { colors = {} } }) =>
    colors.outlineVariant ??
    colors.outline ??
    'color-mix(in oklch, currentColor 10%, transparent)'};

  ${({ $orientation, $thickness, $length, $inset }) =>
    $orientation === DIVIDER_ORIENTATION_VERTICAL
      ? css`
          width: ${$thickness}px;
          height: ${lengthValue($length ?? 18)};
          margin: 0 ${insetValue($inset)};
          align-self: center;
        `
      : css`
          height: ${$thickness}px;
          width: ${lengthValue($length)};
          margin: ${insetValue($inset)} 0;
        `}
`;
